
import { createElement } from "react";
import React from "react";
import { useTranslation } from "react-i18next";
import { reactElement, reactApi } from "../../../fable_modules/Feliz.2.9.0/Interop.fs.js";
import { equals, int32ToString, createObj } from "../../../fable_modules/fable-library-js.5.0.0-rc.2/Util.js";
import { concat, join } from "../../../fable_modules/fable-library-js.5.0.0-rc.2/String.js";
import { UpdateMinimumStockQuantityDialog, NewMinimumStockQuantityDialog } from "../Dialogs/MinimumStockDialog.js";
import { StorageTableRow, Msg } from "./Types.js";
import { LabelId__get_unwrap, CategoryMinimumQuantityId as CategoryMinimumQuantityId_1, StorageId as StorageId_1 } from "../../../Shared/Shared.js";
import { ConfirmationDialog } from "../../../Components/Dialog.js";
import { TableControl$1, Table } from "../../../Widgets/Table/Table.js";
import { singleton, append, tryFind, ofArray, tryHead, isEmpty, map, toArray } from "../../../fable_modules/fable-library-js.5.0.0-rc.2/List.js";
import { ColumnDefinition$1, CellContent } from "../../../Widgets/Table/Types.js";
import Notification_Alarm_1 from "../../../../public/assets/icons/Notification_Alarm_1.svg";
import Recycle_Bin_1 from "../../../../public/assets/icons/Recycle_Bin_1.svg";
import { Hierarchy_getChildren, Label as Label_2, Hierarchy_getAncestors } from "../../../Shared/Category.js";
import { unwrap, map as map_1 } from "../../../fable_modules/fable-library-js.5.0.0-rc.2/Option.js";
import { DetailViewHeader } from "../../../Widgets/DetailViewHeader.js";
import { Badge } from "../../../Components/Badge.js";
import { RouterModule_nav } from "../../../fable_modules/Feliz.Router.4.0.0/Router.fs.js";
import { empty, singleton as singleton_1, append as append_1, delay, toList } from "../../../fable_modules/fable-library-js.5.0.0-rc.2/Seq.js";
import { LabeledValue } from "../../../Components/Text.js";
import { Checkbox } from "../../../Components/Checkbox.js";
import { React_useElmish_Z6C327F2E } from "../../../fable_modules/Feliz.UseElmish.2.5.0/UseElmish.fs.js";
import { ProgramModule_mkProgram } from "../../../fable_modules/Fable.Elmish.5.0.2/program.fs.js";
import { update as update_1, init as init_1 } from "./State.js";
import { Skeleton } from "../../../Components/Skeleton.js";

function StorageMinimumQuantitySection(props) {
    let elems, StorageId, Title, TableRows, Options;
    const t = useTranslation()[0];
    const patternInput_1 = reactApi.useState(false);
    const setIsNewMinimumStockQuantityDialogOpen = patternInput_1[1];
    const patternInput_2 = reactApi.useState(undefined);
    const setIsEditMinimumStockQuantityDialogOpen = patternInput_2[1];
    const isEditMinimumStockQuantityDialogOpen = patternInput_2[0];
    const patternInput_3 = reactApi.useState(undefined);
    const setIsDeleteMinimumStockQuantityDialogOpen = patternInput_3[1];
    const isDeleteMinimumStockQuantityDialogOpen = patternInput_3[0];
    return reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col", "bg-white"])], (elems = [createElement(NewMinimumStockQuantityDialog, {
        CategoryId: props.CategoryId,
        IsOpen: patternInput_1[0],
        OnClose: () => {
            setIsNewMinimumStockQuantityDialogOpen(false);
        },
        SuccessCallback: () => {
            props.Dispatch(new Msg(1, []));
        },
    }), createElement(UpdateMinimumStockQuantityDialog, (StorageId = ((isEditMinimumStockQuantityDialogOpen == null) ? (new StorageId_1("00000000-0000-0000-0000-000000000000")) : isEditMinimumStockQuantityDialogOpen[0]), {
        CategoryId: props.CategoryId,
        CategoryMinimumQuantityId: (isEditMinimumStockQuantityDialogOpen == null) ? (new CategoryMinimumQuantityId_1("00000000-0000-0000-0000-000000000000")) : isEditMinimumStockQuantityDialogOpen[1],
        IsOpen: isEditMinimumStockQuantityDialogOpen != null,
        OnClose: () => {
            setIsEditMinimumStockQuantityDialogOpen(undefined);
        },
        StorageId: StorageId,
        SuccessCallback: () => {
            props.Dispatch(new Msg(1, []));
        },
    })), createElement(ConfirmationDialog, (Title = t("category.delete_minimum_quantity_title"), {
        Description: t("category.delete_minimum_quantity_description"),
        IsOpen: isDeleteMinimumStockQuantityDialogOpen != null,
        OnClose: () => {
            setIsDeleteMinimumStockQuantityDialogOpen(undefined);
        },
        OnConfirm: () => {
            if (isDeleteMinimumStockQuantityDialogOpen == null) {
            }
            else {
                props.Dispatch(new Msg(5, [isDeleteMinimumStockQuantityDialogOpen]));
                setIsDeleteMinimumStockQuantityDialogOpen(undefined);
            }
        },
        Title: Title,
    })), createElement(Table, (TableRows = toArray(map((minimumQuantity) => (new StorageTableRow(minimumQuantity.CategoryMinimumQuantityId, minimumQuantity.StorageId, minimumQuantity.StorageName, minimumQuantity.Quantity)), props.Category.MinimumQuantityStorages)), (Options = {
        BorderStyle: "row",
        CSVDownload: false,
        ConfigurableColumns: false,
        CustomTableFilters: false,
        DefaultSortColumn: ["name", "asc"],
        Fullscreen: false,
        GlobalSearch: false,
        RowSelection: "singleRow",
        SaveTableConfiguration: false,
    }, {
        ColumnDefinitions: [new ColumnDefinition$1("name", "", t("general.storage"), (row) => (new CellContent(0, [row.StorageName])), "none", "text"), new ColumnDefinition$1("minimum-quantity", "", t("general.minimum_quantity"), (row_1) => (new CellContent(0, [int32ToString(row_1.MinimumQuantity)])), "none", "text")],
        Controls: ofArray([new TableControl$1(t("category.add_minimum_quantity"), Notification_Alarm_1(), (_arg_6) => {
            setIsNewMinimumStockQuantityDialogOpen(true);
        }, false, false, ""), new TableControl$1(t("category.edit_minimum_quantity"), Notification_Alarm_1(), (selectedStorage) => {
            if (isEmpty(selectedStorage)) {
            }
            else {
                const matchValue = tryHead(map((row_2) => [row_2.StorageId, row_2.CategoryMinimumQuantityId], selectedStorage));
                if (matchValue == null) {
                }
                else {
                    setIsEditMinimumStockQuantityDialogOpen([matchValue[0], matchValue[1]]);
                }
            }
        }, true, true, ""), new TableControl$1(t("general.delete"), Recycle_Bin_1(), (selectedSps) => {
            if (isEmpty(selectedSps)) {
            }
            else {
                const matchValue_1 = tryHead(map((_arg_7) => _arg_7.CategoryMinimumQuantityId, selectedSps));
                if (matchValue_1 == null) {
                }
                else {
                    setIsDeleteMinimumStockQuantityDialogOpen(matchValue_1);
                }
            }
        }, true, false, "")]),
        Options: Options,
        TableKey: "category-minimum-stock-table",
        TableRows: TableRows,
    })))], ["children", reactApi.Children.toArray(Array.from(elems))])])));
}

export function CategoryDetail(props) {
    let elems_6, Title, elems_5, SubTitle, elems_4;
    const t = useTranslation()[0];
    const patternInput_1 = reactApi.useState(false);
    const setIsDeleteDialogOpen = patternInput_1[1];
    const isDeleteDialogOpen = patternInput_1[0];
    const ancestors = Hierarchy_getAncestors(props.AllCategories, new Label_2(props.Category.Id, props.Category.Name, props.Category.ColorHex, props.Category.VisibleForUserRole, props.Category.ParentLabelId));
    const children = Hierarchy_getChildren(props.AllCategories, props.Category.Id);
    let parentCategoryName;
    const matchValue = props.Category.ParentLabelId;
    if (matchValue == null) {
        parentCategoryName = undefined;
    }
    else {
        const parentId = matchValue;
        parentCategoryName = map_1((_arg) => _arg.Name, tryFind((c) => equals(c.Id, parentId), props.AllCategories));
    }
    const hierarchyPath = isEmpty(ancestors) ? props.Category.Name : join(" > ", append(map((_arg_1) => _arg_1.Name, ancestors), singleton(props.Category.Name)));
    return reactElement("div", createObj(singleton((elems_6 = [createElement(ConfirmationDialog, (Title = t("general.remove"), {
        Description: t("category.delete_question"),
        IsOpen: isDeleteDialogOpen,
        OnClose: () => {
            setIsDeleteDialogOpen(false);
        },
        OnConfirm: () => {
            props.Dispatch(new Msg(0, []));
        },
        Title: Title,
    })), reactElement("div", createObj(ofArray([["className", join(" ", ["max-w-[75rem]"])], (elems_5 = [createElement(DetailViewHeader, (SubTitle = (isEmpty(ancestors) ? undefined : hierarchyPath), {
        Badges: append(map((a) => createElement(Badge, {
            Color: a.ColorHex,
            Label: a.Name,
            TestId: concat("ancestor-badge-", ...LabelId__get_unwrap(a.Id)),
        }), ancestors), singleton(createElement(Badge, {
            Color: props.Category.ColorHex,
            Label: props.Category.Name,
            TestId: "current-category-badge",
        }))),
        OnBack: () => {
            RouterModule_nav(ofArray(["settings", "categories"]), 1, 1);
        },
        OnDelete: () => {
            setIsDeleteDialogOpen(!isDeleteDialogOpen);
        },
        OnEdit: () => {
            RouterModule_nav(ofArray(["settings", "categories", LabelId__get_unwrap(props.Category.Id), "edit"]), 1, 1);
        },
        SubTitle: unwrap(SubTitle),
        Title: props.Category.Name,
    })), reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-shrink-0", "flex-col", "gap-4", "mb-3", "bg-white", "rounded", "px-12", "py-9"])], (elems_4 = toList(delay(() => append_1(singleton_1(LabeledValue({
        Label: t("general.name"),
        Value: props.Category.Name,
    })), delay(() => {
        let matchValue_1, name;
        return append_1((matchValue_1 = parentCategoryName, (matchValue_1 == null) ? (empty()) : ((name = matchValue_1, singleton_1(LabeledValue({
            Label: t("category.parent_category"),
            Value: name,
        }))))), delay(() => append_1(singleton_1(LabeledValue({
            Label: t("category.hierarchy_path"),
            Value: hierarchyPath,
        })), delay(() => {
            let elems_1, elems;
            return append_1(!isEmpty(children) ? singleton_1(reactElement("div", createObj(singleton((elems_1 = [reactElement("div", {
                className: join(" ", ["font-bold", "mb-1"]),
                children: t("category.child_categories"),
            }), reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-wrap", "gap-2"])], (elems = toList(delay(() => map((child) => createElement(Badge, {
                Color: child.ColorHex,
                Label: child.Name,
                TestId: concat("child-badge-", ...LabelId__get_unwrap(child.Id)),
            }), children))), ["children", reactApi.Children.toArray(Array.from(elems))])])))], ["children", reactApi.Children.toArray(Array.from(elems_1))]))))) : empty(), delay(() => {
                let elems_3, elems_2;
                return append_1(singleton_1(reactElement("div", createObj(ofArray([["className", join(" ", ["mb-3"])], (elems_3 = [reactElement("div", {
                    className: join(" ", ["font-bold", "mb-1"]),
                    children: t("category.color"),
                }), reactElement("div", createObj(ofArray([["className", join(" ", ["w-20"])], (elems_2 = [createElement(Badge, {
                    Color: props.Category.ColorHex,
                    Label: props.Category.ColorHex,
                    TestId: "new-category-test-id",
                })], ["children", reactApi.Children.toArray(Array.from(elems_2))])])))], ["children", reactApi.Children.toArray(Array.from(elems_3))])])))), delay(() => singleton_1(Checkbox({
                    ComponentState: "disabled",
                    IsChecked: props.Category.VisibleForUserRole,
                    Label: t("category.visible_for_user"),
                    OnCheck: (value_15) => {
                    },
                    TestId: "",
                }))));
            }));
        }))));
    })))), ["children", reactApi.Children.toArray(Array.from(elems_4))])]))), createElement(StorageMinimumQuantitySection, {
        Category: props.Category,
        CategoryId: props.Category.Id,
        Dispatch: props.Dispatch,
    })], ["children", reactApi.Children.toArray(Array.from(elems_5))])])))], ["children", reactApi.Children.toArray(Array.from(elems_6))]))));
}

export function View(props) {
    const patternInput = React_useElmish_Z6C327F2E(() => ProgramModule_mkProgram(init_1, update_1, (_arg, _arg_1) => {
    }), props.CategoryId, undefined);
    const state_1 = patternInput[0];
    const matchValue = state_1.Category;
    const matchValue_1 = state_1.AllCategories;
    let matchResult, allCategories, category;
    if (matchValue.tag === 1) {
        if (matchValue_1.tag === 1) {
            matchResult = 0;
            allCategories = matchValue_1.fields[0];
            category = matchValue.fields[0];
        }
        else {
            matchResult = 1;
        }
    }
    else {
        matchResult = 1;
    }
    switch (matchResult) {
        case 0:
            return createElement(CategoryDetail, {
                AllCategories: allCategories,
                Category: category,
                Dispatch: patternInput[1],
            });
        default:
            return createElement(Skeleton, {
                Variant: "detail",
            });
    }
}

